// @flow

import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { EnquireArtistCommissionFormModel } from 'shared_models/forms/ArtistCommission';
import { TermsSection } from 'shared_components/forms/common/TermsSection';
import { DescriptionSection } from 'shared_components/forms/enquire/sections/Description';
import { CreateMailingListMutation } from 'shared_data/providers/queries/CreateMailingListMutation';
import { WithEnquireSuccess } from 'shared_hocs/forms/WithEnquireSuccess';
import { EnquireForm } from 'shared_hocs/forms/Enquire';
import { gtmArtistCommissionOpen } from 'shared_data/providers/google/tagmanager/Actions';
import { artistCommissionRequestSend } from 'shared_services/redux/actions/application/enquire';
import { LocalizedConfig } from 'shared_services/riseart/utils/LocalizedConfig';

import { enquireFormCls } from 'shared_components/forms/enquire/Form.less';

type Props = {
  onClose: Function,
  artist: Object,
};

/**
 * EnquireCommissionForm
 */
export const EnquireCommissionForm = ({ artist, onClose }: Props) => (
  <WithEnquireSuccess onClose={onClose}>
    {({ onSubmit }) => (
      <section className={enquireFormCls}>
        <DescriptionSection phone={LocalizedConfig.get('contact.advisor.phone')}>
          <FormattedMessage
            id="forms.enquireArtistCommission.description"
            values={{ artistName: artist.name, strong: (chunk) => <strong>{chunk}</strong> }}
          >
            {(mainDescription: string) => mainDescription}
          </FormattedMessage>
        </DescriptionSection>

        <FormattedMessage id="forms.enquireArtistCommission.submitBtn">
          {(actionLabel: string) => (
            <Fragment>
              <CreateMailingListMutation>
                {(createMailingList) => (
                  <EnquireForm
                    actionOpen={gtmArtistCommissionOpen}
                    actionSubmit={artistCommissionRequestSend}
                    onSubmit={onSubmit}
                    submitActionLabel={actionLabel}
                    trackedData={{ artist }}
                    formSettings={EnquireArtistCommissionFormModel}
                    createMailingList={createMailingList}
                  />
                )}
              </CreateMailingListMutation>
              <TermsSection translationValues={{ actionLabel }} />
            </Fragment>
          )}
        </FormattedMessage>
      </section>
    )}
  </WithEnquireSuccess>
);
